const downloadUrl = (url: string, name = "file.csv", target?: string): void => {
  // Create a link element
  const link = document.createElement("a")

  // Set link's href to point to the Blob URL
  link.href = url
  link.download = name

  if (target) {
    link.target = target
  }

  // Append link to the body
  document.body.appendChild(link)

  // Dispatch click event on the link
  // This is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window
    })
  )

  // Remove link from body
  document.body.removeChild(link)
}

export default downloadUrl
